
import { ReactNode } from "react";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { StepProgressBar } from "@/components/StepProgressBar";

interface OnboardingLayoutProps {
  children: ReactNode;
}

export function OnboardingLayout({ children }: OnboardingLayoutProps) {
  return (
    <div className="min-h-[100dvh] flex flex-col bg-gradient-to-b from-white to-slate-50">
      <header className="sticky top-0 z-10 backdrop-blur-sm bg-white/80 border-b border-slate-100 shadow-sm">
        <div className="container py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <a href="/" className="flex items-center gap-2 group">
              <div className="flex items-center justify-center h-7 w-7 rounded-full bg-slate-100 text-burgundy group-hover:bg-burgundy/10 group-hover:text-burgundy transition-colors">
                <ArrowLeft className="h-4 w-4" />
              </div>
              <Logo size="sm" showText />
            </a>
          </div>
        </div>
        <div className="container pb-3">
          <StepProgressBar />
        </div>
      </header>
      
      <main className="flex-1 py-6" style={{ backgroundImage: 'url(/lovable-uploads/8de85b8e-9951-48a2-a2ac-c87af6b3c2e8.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          className="container max-w-xl"
        >
          <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-sm p-6 border border-gray-100">
            {children}
          </div>
        </motion.div>
      </main>
      
      <footer className="py-4 text-center text-xs text-slate-500 border-t border-slate-100 bg-white/50 backdrop-blur-sm">
        <div className="container">
          <p>© {new Date().getFullYear()} Cray Cray Reposters. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
